import { createActionHelpers } from 'vuex-loading';
import Event from '@js/franchise_component/franchise-inventory/stock/stock-event';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    stock: {
        product_name: null,
    },
    stockList: [],
    loading: true,
};

const getters = {
    stock: state => state.stock,

    stockList: state => state.stockList,

    loading: state => state.loading,
};

const mutations = {
    setStock(state, data) {
        state.stock = data;
    },

    setStockList(state, data) {
        state.stockList = data;
    },

    setLoading(state, data) {
        state.loading = data;
    },

    setEmptyStockList(state) {
        state.stockList = [];
    },
};

const actions = {
    async getStockList({ commit, dispatch }, params = {}) {
        const url = Laroute.route('inventory.stock.selector');

        const options = {
            params: Object.assign(
                {
                    query: null,
                    limit: 15,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-stocks');

        try {
            const { data } = await axios.get(url, options);
            let res = data.data;

            endLoading(dispatch, 'fetch-stocks');
            commit('setStockList', res);
            commit('setLoading', false);

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-stocks');
            throw e;
        }
    },

    async getStock({ commit, dispatch }, unique_id) {
        const url = Laroute.route('inventory.stock.show', { unique_id });
        startLoading(dispatch, 'fetch-stock');

        try {
            const { data } = await axios.get(url);
            endLoading(dispatch, 'fetch-stock');
            commit('setStock', data);
            Event.$emit('show_modal');

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-stock');
            throw e;
        }
    },

    async updateStock({ commit, dispatch }, params) {
        const url = Laroute.route('inventory.stock.update');
        startLoading(dispatch, 'save-stock');

        try {
            const { data } = await axios.put(url, params);
            endLoading(dispatch, 'save-stock');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-stock');
            throw e;
        }
    },

    async migrateStock({ commit, dispatch }, formData) {
        startLoading(dispatch, 'migrate-stock');
        const url = Laroute.route('inventory.stock.migrate');
        const headers = {
            'Content-Type': 'multipart/form-data',
        };

        try {
            const { data } = await axios.post(url, formData, {
                headers: headers,
            });

            endLoading(dispatch, 'migrate-stock');

            if (data) {
                const options = {
                    data: JSON.stringify(data),
                };

                window.open(
                    Laroute.route(
                        'inventory.stock.download.missing.product',
                        options,
                    ),
                    '_blank',
                );
            }
        } catch (e) {
            endLoading(dispatch, 'migrate-stock');
            throw e;
        }
    },

    emptyStockList({ commit }, params) {
        commit('setEmptyStockList');
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/inventory-stock.js